import React from 'react';
import { number, string } from 'prop-types';
import { N400 } from '@/colors/colorsV1';

const Min = ({ color, size, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13 8L3 8"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

Min.propTypes = {
  color: string,
  size: number,
};

Min.defaultProps = {
  color: N400,
  size: 16,
};

export default Min;
